import { Avatar, Stack, Typography } from '@mui/material';
import { WarningRedTriangle } from 'Images';

interface IWarningMessageWithIcon {
  message: string;
  icon?: string;
  id: string;
}

export const WarningMessageWithIcon = ({
  message,
  icon,
  id,
}: IWarningMessageWithIcon) => {
  return (
    <Stack
      sx={{
        flexDirection: 'row',
        gap: '8px',
        '.MuiTypography-root': {
          fontSize: '14px',
          lineHeight: '16px',
          fontWeight: 400,
        },
      }}
    >
      <Avatar
        alt=''
        src={icon || WarningRedTriangle}
        sx={{ width: '16px', height: '16px' }}
      />
      <Typography id={id.trim().replace(' ', '-')} role='alert'>
        {message}
      </Typography>
    </Stack>
  );
};
